import { ADD_MEDICAL_RECORDS_NOTES, GET_MEDICAL_RECORDS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface MedicalRecordsNotesResponse {
    id: string;
}

export default (
    ptId: string,
    document_id: string,
    notes: string,
): Promise<MedicalRecordsNotesResponse> =>
    fetchWithRefresh(ADD_MEDICAL_RECORDS_NOTES(ptId, document_id), {
        method: 'POST',
        body: JSON.stringify({
            text: notes,
        }),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('upload medical records notes failed');
        }
    });
